import type { ArtistWorkHistory } from '@customTypes/types';
import { Stack } from '@mantine/core';

import { PortfolioItemCard } from '@/features/artist/portfolio';

export const WorkHistoryList = ({ data }: { data: ArtistWorkHistory[] }) => (
  <Stack gap={16}>
    {data.map((item) => (
      <PortfolioItemCard {...item} key={item.clubName} />
    ))}
  </Stack>
);
